import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=1e54fb14&scoped=true"
import script from "./PageForbidden.vue?vue&type=script&lang=js"
export * from "./PageForbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54fb14",
  null
  
)

export default component.exports